import axios from 'axios';
import { environment } from '../config';

// Signing links use their own scoped token. A portal 401 must not sign an
// unrelated staff session out or attach its bearer token to the request.
export default axios.create({ baseURL: environment.apiUrl, timeout: 120000 });
